import { g as A } from "./_commonjsHelpers-OnjxAlhP.js";
import { i as O } from "./isType-dZyoyzn5.js";
var p = /* @__PURE__ */ ((t) => (t.VIEW_CONDITION = "view_condition", t.INTERACTION = "interaction", t.FOLLOW_SALE = "follow_sale", t.FOLLOW_LOT = "follow_lot", t.SHARE = "share", t.ADD_CALENDAR = "add_calendar", t.SEARCH = "search", t.FILTER = "filter", t.LOT_FILTER_EMPTY_RESULTS = "lot_filter_empty_results", t.BANNER_OPEN = "banner_open", t.BANNER_CLOSE = "banner_close", t.ENQUIRE_LOAD = "enquire_load", t.ENQUIRE_SUBMIT = "enquire_submit", t.ERROR = "error", t.PAGE_VIEW = "page_view", t.SAVE_INTEREST = "save_interest", t))(p || {});
const L = "CHR_LOGGING", E = "data-analytics-region", N = "data-track", S = (t) => {
  const a = t.target;
  if (!(a instanceof HTMLElement))
    return;
  const l = ((r) => r.nodeName === "A" || r.nodeName === "BUTTON" ? r : r.closest("a") || r.closest("button"))(a);
  if (!(l instanceof HTMLAnchorElement) && !(l instanceof HTMLButtonElement) || l.closest("chr-button"))
    return;
  const s = l.getAttribute(N);
  if (!s)
    return;
  const n = s.split("|"), u = n.length > 1 && n[0] || R(l), c = (n.length > 1 ? n[1] : n[0]) || "type undefined", i = (n.length > 2 ? n[2] : "") || "";
  I({
    event: p.INTERACTION,
    data: {
      interaction: {
        type: c,
        destination: i,
        location: u
      }
    }
  });
}, b = () => localStorage.getItem(`${L}_DEBUG`) === "true", R = (t) => {
  var a;
  return O(t, "closest") && ((a = t.closest(`[${E}]`)) == null ? void 0 : a.getAttribute(`${E}`)) || "region undefined";
}, I = (...t) => {
  var r, _;
  const a = t.map((e) => e.event).filter((e, o, f) => f.indexOf(e) !== o);
  if (a.length > 0)
    throw new Error(`Duplicated tracked events detected. Duplicated events: ${a.join(", ")}`);
  const d = t.filter((e) => e.data), s = d.reduce(
    (e, o) => o.data ? e.concat(Object.keys(o.data)) : e,
    []
  ).filter((e, o, f) => f.indexOf(e) !== o);
  if (s.length > 0)
    throw new Error(`Duplicated event payload detected. Duplicated payloads: ${s.join(", ")}`);
  const n = t.reduce((e, o) => ({ ...e, [o.event]: !0 }), {}), u = d.reduce((e, o) => ({ ...e, ...o.data }), {}), c = {
    events: {
      ...n
    },
    ...u
  };
  console.info("LOG SERVICE: track", t, JSON.stringify(c));
  const i = (_ = (r = A()) == null ? void 0 : r.window) == null ? void 0 : _._trackData;
  if (!i) {
    console.warn("LOG SERVICE: _trackData not available");
    return;
  }
  try {
    i(c);
  } catch (e) {
    console.warn("ANALYTICS: failed to log event", e);
  }
};
export {
  p as T,
  S as c,
  R as g,
  b as i,
  I as t
};
